'use strict';
import {Observable} from 'rxjs/Observable';

module.exports = [
  AttrsToObservable];

function AttrsToObservable() {
  return function ($attrs) {
    Object.defineProperty($attrs, '$toObservable', {
      configurable: true,
      writable: true,
      enumerable: false,
      value: function (watchExpression) {
        return Observable.create(function (observer) {
          // Create function to handle old and new Value
          function listener(newValue) {
            observer.next(newValue);
          }

          // Returns function which disconnects the $watch expression
          return $attrs.$observe(watchExpression, listener);
        });
      }
    });
  }
}


// WEBPACK FOOTER //
// ./src/js/core-utilities/angular-rx-attrs/$attrsToObservable.js